import { Component, OnInit } from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap'; //, ModalDismissReasons
import { FormBuilder, Validators} from '@angular/forms'; //FormGroup, FormControl,
import { Router } from '@angular/router'; //, NavigationExtras

//import { SigninUpComponent } from '../signin-up/signin-up.component';

import { UserProvider } from '../providers/user/user';
import { BasicProvider } from '../providers/basic/basic';

@Component({
  selector: 'app-shipping-address',
  templateUrl: './shipping-address.component.html',
  styleUrls: ['./shipping-address.component.css']
})
export class ShippingAddressComponent implements OnInit {

  homeAddrForm;
  countries;
  isDisabled = true;

  validation_message = {
    'country_id': {
      'required': 'Please select country.'
    },
    'island_id': {
      'required': 'Please select Island/Parish.'
    },
    'address': {
      'required': 'Please provide address.'
    },
    'city': {
      'required': 'Please provide city.'
    },
    'phone': {
      'required': 'Please provide phone number.',
      'pattern': 'Please enter valid phone.',
      'minlength': 'phone number length must be between 8 to 10.',
      'maxlength': 'phone number length must be between 8 to 10.'
    }
  };
  
  constructor(
    private modalService: NgbModal,
    public bp:BasicProvider, 
    public up:UserProvider,
    public builder:FormBuilder,
    public router: Router,
  ) { 

    this.addrValidate();
    //this.getData();
  }

  ngOnInit() {
    this.getData();
  }

  getData(){
    if(true|| !this.up.isContryData){
      this.bp.hitApi('settings/get_country_island', 'GET', {},true)
      .subscribe(
        success => { 
          if ( success.type == true ) { 
            this.up.countryData = success.data; 
            this.countries = this.up.getCountry(); 
          } else {
            
          } 
        }, 
        error => {
          console.log(error);
        }
      );
    }
    else{
      //this.countries = this.up.getCountry();
    }
  }

  states;
  changeCountry(e: any){
    this.isDisabled = false;
    this.states = this.up.getState(e);
    //console.log(this.states);
  }

  addrValidate() {
    this.bp.validation_error = '';
    this.homeAddrForm = this.builder.group({
      country_id: ['', Validators.compose([this.bp.required])], 
      island_id: ['', Validators.compose([this.bp.required])], 
      city: ['', Validators.compose([this.bp.required])], 
      phone: ['', Validators.compose([this.bp.required, Validators.pattern(/^[0-9]+/), Validators.minLength(8), Validators.maxLength(10)])], 
      address: ['', Validators.compose([this.bp.required])], 
      comments: [''] 
    });
  }

  async addrSubmit() {

    if (this.bp.validation(this.homeAddrForm, this.validation_message)) {

      let submitData = this.homeAddrForm.value;
      var data = this.updateAddressData(submitData);
      //console.log(data);
      this.bp.hitApi('users/save_address', 'POST', data,true,true)
        .subscribe(
          success => {
            if (success.type == true) {
              this.up.setUserAddressCount('home_address','1');
              this.bp.show_toast('Success',success.message);
              this.addrValidate();
              this.redirect();
            } else {
              this.bp.show_toast('Error',success.message);
            }
          }, 
          error => {

          }
        );
    }
  }

  redirect() {
    if (!this.up.isLoggedIn) {
      //this.bp.model_type = 'signin';
      //this.bp.model = this.modalService.open(SigninUpComponent, { windowClass: 'signUp-modal' });
      //return false;
      this.router.navigate(['home']);
    } else {
      this.router.navigate(['home']);
    }
    
  }

  updateAddressData(data){
    let submitData = data;
    submitData.address_type = 'Home';
    let address = [];
    address.push(submitData);
    return Object.assign({}, {address:address});
  }

}



// WEBPACK FOOTER //
// ./src/app/shipping-address/shipping-address.component.ts